import { render, staticRenderFns } from "./WaiZhaoBaoZhuangKanban.vue?vue&type=template&id=93218c82&"
import script from "./WaiZhaoBaoZhuangKanban.vue?vue&type=script&lang=js&"
export * from "./WaiZhaoBaoZhuangKanban.vue?vue&type=script&lang=js&"
import style0 from "./WaiZhaoBaoZhuangKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports